module.exports = __webpack_public_path__ + "static/media/Schussel.71b0fb4d.mp3";